import React from "react"
import styles from '../styles/contact.module.scss'
import Layout from "../components/layout"
import SEO from "../components/seo"
import ContactForm from '../components/FreeWorkoutForm'

//Contact Page
const Contact = () => (
  <Layout>
    <SEO title="404: Not found" />
    <div className={styles.text}>
    <h1>Get In Touch</h1>
    <p>Complete the form below if you have any questions or comments! Thanks for being a huge part of the emPOWERed community!</p>
    </div>
    <div>
        <ContactForm />
    </div>
  </Layout>
)

export default Contact
